import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useSettingsContext } from '../../../components/settings/index.js';
import { Typography, Container} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/index.js';
import {CompanyClassListView} from '../class/index.js'


// ----------------------------------------------------------------------

export default function ClassViewCompany() {
  const { state } = useLocation();
  const settings = useSettingsContext();

  // const { enqueueSnackbar } = useSnackbar();




  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Grid container spacing={3} sx={{py: 2}}>
      <CompanyClassListView companyinfo={state}/>

      </Grid>
    </Container>
  );
}

ClassViewCompany.propTypes = {
  currentUser: PropTypes.object,
};
